/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';

export type TChangePriceUnsubscribeModel = IModel<IChangePriceUnsubscribeRequest, TChangePriceUnsubscribeResponse>;

export interface IChangePriceUnsubscribeRequest {
  offerId: number;
  uuid?: string | null;
}

export type TChangePriceUnsubscribeResponse = IChangePriceUnsubscribeResponse200 | IChangePriceUnsubscribeResponse400;

export interface IChangePriceUnsubscribeResponse200 extends IModelResponse<IChangePriceUnsubscribeResponse> {
  statusCode: 200;
}

export interface IChangePriceUnsubscribeResponse400 extends IModelResponse<IChangePriceUnsubscribeResponseError> {
  statusCode: 400;
}

export interface IChangePriceUnsubscribeResponse {
  status: EStatus;
}

export interface IChangePriceUnsubscribeResponseError {
  errors: any[];
  message: string;
}

export type TResponses = IChangePriceUnsubscribeResponse | IChangePriceUnsubscribeResponseError;

export enum EStatus {
  /** undefined **/
  Ok = 'ok',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IChangePriceUnsubscribeResponse): TResponse200;
  400(response: IChangePriceUnsubscribeResponseError): TResponse400;
}
